var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('shit-shell',{attrs:{"title":"Today"}},_vm._l((_vm.shits),function(shit){return _c('shit-todo',{key:shit.uuid,ref:"shits",refInFor:true,attrs:{"shit":shit}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }